/**
 * RESPONSIBILITY: draw an event's prose.
 *
 * The HTML was rendered when the event was saved and is never built here — see
 * @RenderOf. That is what keeps the markdown parser out of the browser bundle and what
 * makes this safe to hand to dangerouslySetInnerHTML: nothing a client sent can reach it.
 */
import { Html } from '@framework/react';
import { THEME } from '@app/sections';
import { Band } from './Band';
import type { BandProps } from './kind';

export function Body({ s }: BandProps) {
  if (!s.bodyHtml) return null;

  return (
    <Band theme={THEME.Body} heading={s.heading}>
      <Html className="md-body ev-prose">{s.bodyHtml}</Html>
    </Band>
  );
}
